export default defineNuxtPlugin(() => {
  const {
    public: { appEnv, GTM_ID, GTM_AUTH },
  } = useRuntimeConfig()

  useHead({
    meta:
      appEnv === 'production'
        ? [
            {
              name: 'google-site-verification',
              content: 'aL39PPD6w-0DmzqUegDFvVMe-ENNFbEYgB_lDTRq0kE',
            },
            {
              name: 'google-site-verification',
              content: 'c3vBf0YDxoRoX_I6pV1JVuiW8CdVApb6PBEZ_kWtl4c',
            },
          ]
        : [
            {
              name: 'robots',
              content: 'noindex, nofollow',
            },
          ],
  noscript: [
    {
      innerHTML: `
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}${GTM_AUTH}"
          height="0"
          width="0"
          style="display:none;visibility:hidden"
        ></iframe>
      `,
      tagPosition: 'bodyClose',
    },
  ],
  })
})
